import styled from 'styled-components'

import { Polygon } from 'components/polygon'
import { theme } from 'styles/theme'

const { colors, media, radii, space, zIndices } = theme

export const Simulation = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 58.5rem;
  overflow: hidden;
  background-color: #00203c;

  @media (${media.phone}) {
    min-height: 38rem;
  }
`

export const Content = styled.div`
  position: relative;
  z-index: ${zIndices[1]};
  padding: 5rem 8.5rem 5.5rem;

  @media (${media.phone}) {
    padding: 6rem ${space['spacing-md']} 7rem;
  }
`

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-sm']};
  width: 100%;
  max-width: 56rem;
  margin: 0 auto;
  padding: ${space['spacing-xxl']} ${space['spacing-md']} ${space['spacing-md']};
  border-radius: ${radii['corner-radius-lg']};
  background-color: #1852FE;

  @media (${media.tablet}) {
    padding: ${space['spacing-mega']} ${space['spacing-giga']};
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-sm']};
`

export const GifWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 34rem;
  margin: 0 auto;
  aspect-ratio: 16 / 10;

  img {
    object-fit: contain;
  }

  @media (${media.phone}) {
    width: auto;
    max-width: none;
    margin-left: -${space['spacing-sm']};
    margin-right: -${space['spacing-sm']};
    aspect-ratio: 5 / 4;

    img {
      object-fit: cover;
    }
  }
`

const connectorLine = colors['cyan-background-pressed']

export const ConnectorTriangle = styled(Polygon)`
  position: absolute;
`

export const TopConnector = styled.span`
  display: block;
  position: absolute;
  left: ${space['spacing-xxl']};
  bottom: 100%;
  width: 100vw;
  height: ${space['spacing-mega']};
  border-top: 1px solid ${connectorLine};
  border-left: 1px solid ${connectorLine};
  border-top-left-radius: 2rem;
  pointer-events: none;

  @media (${media.desktop}) {
    left: 18rem;
    height: 5.5rem;
    border-top-left-radius: ${space['spacing-xxxl']};
  }

  ${ConnectorTriangle} {
    top: -1.0rem;
    left: 4rem;
    width: 1.25rem;
    height: 2.00rem;

    @media (${media.desktop}) {
      left: 7rem;
    }
  }
`

export const BottomConnector = styled.span`
  display: block;
  position: absolute;
  right: ${space['spacing-xxl']};
  top: 100%;
  width: 100vw;
  height: ${space['spacing-mega']};
  border-bottom: 1px solid ${connectorLine};
  border-right: 1px solid ${connectorLine};
  border-bottom-right-radius: 2rem;
  pointer-events: none;

  @media (${media.desktop}) {
    right: 18rem;
    height: 5.5rem;
    border-bottom-right-radius: ${space['spacing-xxxl']};
  }
`

export const CtaWrapper = styled.div`
  position: absolute;
  left: 50%;
  bottom: calc(-1 * ${space['spacing-mega']});
  transform: translate(-50%, 50%);
  z-index: ${zIndices[2]};

  @media (${media.desktop}) {
    bottom: -5.5rem;
  }

  button.ds-button {
    padding: 0 ${space['spacing-xl']};
    gap: ${space['spacing-xxs']};
    background-color: ${colors['cashme-magenta']};
    border-radius: ${radii['corner-radius-pill']};

    &:hover {
      background-color: ${colors['cashme-magenta-alt']};
    }
  }
`
